import { useState } from 'react'
import styles from './PrintPageFanfold.module.css'
import PrintAttendee from './PrintAttendee'
import PrintGuestAttendee from '../../../src/components/Badging/PrintGuestAttendee'
import PrintExtraBadge from '../../../src/components/Badging/PrintExtraBadge'

const PrintPageFanfold = ({
    clientEventInfo,
    registrants,
    registrantPrintSettings,
    guestPrintSettings,
    componentRef,
    printPageBreak,
}) => {
    // State
    const [guestBadgeContainerStyle, setGuestBadgeContainerStyle] = useState(null)
    // Defensive: Use px/in/etc units for width/height
    // Only apply width/height to each badge, not the printArea
    const badgeContainerStyle = {
        width: getWidth(registrantPrintSettings?.badgeDimensions),
        height: getHeight(registrantPrintSettings?.badgeDimensions),
        ...registrantPrintSettings.badgeDimensions?.customStyle,
        boxSizing: "border-box",
        // Ensure background is white for print
        backgroundColor: "white",
        // Avoid overflow for tightly sized badges
        overflow: "hidden",
        margin: registrantPrintSettings?.badgeOrientations?.margin,
        padding: registrantPrintSettings?.badgeOrientations?.padding,
        textAlign: registrantPrintSettings?.badgeOrientations?.textAlign,
        display: registrantPrintSettings?.badgeOrientations?.display,
        position: registrantPrintSettings?.badgeOrientations?.position,
        transform: getTransform(registrantPrintSettings?.badgeOrientations?.upsideDown),
    };
    // Only apply width/height to each badge, not the printArea
    if (guestPrintSettings && guestPrintSettings!== undefined) {
        let guestSetup = {
            width: getWidth(guestPrintSettings?.badgeDimensions),
            height: getHeight(guestPrintSettings?.badgeDimensions),
            ...guestPrintSettings.badgeDimensions?.customStyle,
            boxSizing: "border-box",
            // Ensure background is white for print
            backgroundColor: "white",
            // Avoid overflow for tightly sized badges
            overflow: "hidden",
            margin: guestPrintSettings?.badgeOrientations?.margin,
            padding: guestPrintSettings?.badgeOrientations?.padding,
            textAlign: guestPrintSettings?.badgeOrientations?.textAlign,
            display: guestPrintSettings?.badgeOrientations?.display,
            position: guestPrintSettings?.badgeOrientations?.position,
            transform: getTransform(guestPrintSettings?.badgeOrientations?.upsideDown),
        }
        setGuestBadgeContainerStyle(guestSetup);
    }
    // Only apply width/height to each badge, not the printArea
    function badgeExtraContainerStyle(extrabadge) {
        let tempHolder = isValidJsonString(extrabadge.badgeOrientations) ? JSON.parse(extrabadge.badgeOrientations) : extrabadge.badgeOrientations
        return {
            width: getWidth(extrabadge?.badgeDimensions),
            height: getHeight(extrabadge?.badgeDimensions),
            ...extrabadge?.customStyle,
            boxSizing: "border-box",
            // Ensure background is white for print
            backgroundColor: "white",
            // Avoid overflow for tightly sized badges
            overflow: "hidden",
            margin: tempHolder?.margin,
            padding: tempHolder?.padding,
            textAlign: tempHolder?.textAlign,
            display: tempHolder?.display,
            position: tempHolder?.position,
            transform: getTransform(tempHolder?.upsideDown),
        }
    };
    function getWidth(badgeDimensions) {
        let tempHolder = isValidJsonString(badgeDimensions) ? JSON.parse(badgeDimensions) : badgeDimensions;
        return tempHolder?.width
            ? typeof tempHolder.width === "number"
                ? `${tempHolder.width}px`
                : tempHolder.width : tempHolder.width
    };
    function getHeight(badgeDimensions) {
        let tempHolder = isValidJsonString(badgeDimensions) ? JSON.parse(badgeDimensions) : badgeDimensions;
        return tempHolder?.height
            ? typeof tempHolder.height === "number"
                ? `${tempHolder.height}px`
                : tempHolder.height : tempHolder.height
    };
    function getTransform(upsideDown) {
        return upsideDown ? 'scale(-1, -1)' : 'none'
    };
    function isValidJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false; // Error means it's not a valid JSON string
        }
        return true; // No error means it's a valid JSON string
    }
    return (
        <div
            className={styles.printArea}
            ref={componentRef}
        >
            {registrants?.length > 0
                ? registrants.map((registrant, idx) => (
                    <>
                        <div key={idx}>
                            {/* Only use pageBreakMidAttendee if you want a break between badges on the same page.
                            For badge printers, you usually want pageBreakNewAttendee after each badge. */}
                            {/* <div className={styles.pageBreakMidAttendee}>&nbsp;</div> */}
                            <div
                                className={styles.badgeContainer}
                                style={badgeContainerStyle}
                            >
                                <PrintAttendee
                                    clientEventInfo={clientEventInfo}
                                    stylingForm={registrant}
                                    CSSValues={registrantPrintSettings.cSSValues}
                                    specialCSSRules={registrantPrintSettings.specialCSSRules}
                                    fieldOrdering={registrantPrintSettings.fieldOrdering}
                                />
                                {registrant?.extraBadgeTemplates &&
                                    registrant.extraBadgeTemplates.map((extraBadge, i) => (
                                        <div key={i}>
                                            <div className={styles.badgeContainer} style={badgeExtraContainerStyle(extraBadge)}>
                                                <PrintExtraBadge extraBadge={extraBadge} />
                                            </div>
                                        </div>
                                    ))}

                                {/* Always force a page break after each main badge for badge printers */}
                                {printPageBreak ?
                                    <div className={styles.pageBreakNewAttendee}>&nbsp;</div>
                                    : <></>}
                            </div>
                        </div>
                        <>
                            {
                                registrant.guests?.length > 0 ?
                                    registrant.guestTemplate.map((guest, idx) => (
                                        <div key={'guest' + idx}>
                                            {/* Only use pageBreakMidAttendee if you want a break between badges on the same page.
                            For badge printers, you usually want pageBreakNewAttendee after each badge. */}
                                            {/* <div className={styles.pageBreakMidAttendee}>&nbsp;</div> */}
                                            <div
                                                className={styles.badgeContainer}
                                                style={guestBadgeContainerStyle}
                                            >
                                                <PrintGuestAttendee
                                                    clientEventInfo={clientEventInfo}
                                                    stylingForm={guest.stylingForm}
                                                    CSSValues={guestPrintSettings.cSSValues}
                                                    specialCSSRules={guestPrintSettings.specialCSSRules}
                                                    fieldOrdering={guestPrintSettings.fieldOrdering}
                                                />
                                                {/* Always force a page break after each main badge for badge printers */}
                                                {printPageBreak ?
                                                    <div className={styles.pageBreakNewAttendee}>&nbsp;</div>
                                                    : <></>}
                                            </div>
                                        </div>
                                    ))
                                        :
                                        <></>
                            }
                        </>
                    </>
                    

                ))
                : null}
        </div>
    )
};

export default PrintPageFanfold;